import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Image,
  Card,
  Row,
  Col,
  Switch,
  DatePicker,
  Tabs,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  UserOutlined,
  IdcardOutlined,
 } from "@ant-design/icons";

import { AiOutlineMail, AiOutlineMobile, AiFillDelete } from "react-icons/ai";
 
import Swal from "sweetalert2";
import moment from "moment";

import { useSelector, useDispatch } from "react-redux";
import { userCustomerActions } from "../store";
import userCustomerApi from "../api/userCustomerApi";
import addressApi from "../api/addressApi";
import debounce from "lodash.debounce";
import UploadFile from "../components/UploadFile";
import { fileManagerActions } from "../store";
import ENV from "../consts/config";
import { LocalImage } from "../components/ImageUtil";
import PERMISSION from "../consts/permissions";

const UserCustomer = (props) => {
  const { TabPane } = Tabs;
  const dispatch = useDispatch();

  const { userCustomers, totalCount } = useSelector((x) => x.userCustomer);
  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  // const lstRoles = useSelector((x) => x.role.lstRoles);

  const [loading, setLoading] = useState(false);
  const [isModalEditContractVisible, setIsModalEditContractVisible] =
    useState(false);
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [listDeleted, setListDeleted] = useState([]);
  const [titleModal, setTitleModal] = useState("");
  const [isEditModal, setEditModal] = useState(false);
  const [valueFormUser, setValueFormUser] = useState({
    email: null,
    password: null,
    username: null,
    name: null,
    gender: null,
    phoneLogin: null,
    status: null,
    emailConfirmed: null,
    avatar: null,
    phone: null,
    dob: null,
    details: null,
    province: null,
    district: null,
    village: null,
    provinceName: null,
    districtName: null,
    villageName: null,
    note : null
  });
  const [inputFilter, setFilter] = useState({
    search: null,
    status: null,
    emailConfirmed: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const dateFormat = "DD/MM/YYYY HH:mm:ss";
  const dateFormatOnlyDate = "YYYY/MM/DD";
  const dateFormatUTC = "DD/MM/YYYY";

  const [form] = Form.useForm();
  const [province, setProvince] = useState();
  const [district, setDistrict] = useState();
  const [village, setVillage] = useState();

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  useEffect(() => {
    getUserCustomer();
    form.setFieldsValue(valueFormUser);
  }, [inputFilter, valueFormUser, isEditModal]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter,page: 1, search: e.target.value });
  };

  const getCustomerDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getUserCustomer = () => {
    onSelectChange([], []);
    setLoading(true);
    dispatch(userCustomerActions.getAll(inputFilter)).then(() => {
      setLoading(false);
    });
  };

  const getAddress = (code, type) => {
    const params = {
      parent_code: code,
    };
    addressApi.getAddress(params).then((res) => {
      if (type === "province") {
        setProvince(res);
        setDistrict([]);
        setVillage([]);
      } else if (type === "district") {
        form.setFieldsValue({
          district: null,
          districtName: null,
          villageName: null,
          village: null,
        });
        setDistrict(res);
        setVillage([]);
      } else if (type === "village") {
        form.setFieldsValue({
          village: null,
          villageName: null,
        });
        setVillage(res);
      }
    });
  };

  const getAddressEdit = (code, type) => {
    const params = {
      parent_code: code,
    };
    addressApi.getAddress(params).then((res) => {
      if (type === "province") {
        setProvince(res);
      } else if (type === "district") {
        setDistrict(res);
      } else if (type === "village") {
        setVillage(res);
      }
    });
  };

  const createCustomer = (data) => {
    console.log(fileImageUrl);
    const payload = {
      avatarPath: fileImageUrl,
      email: data.email,
      password: data.password,
      username: data.username,
      name: data.name,
      gender: data.gender,
      phoneLogin: data.phoneLogin == null || !data.phoneLogin ? false : true,
      active: data.active?true:false,
      emailConfirmed:
        data.emailConfirmed == null || !data.emailConfirmed ? false : true,
      avatar: data.avatar,
      phone: data.phone,
      note : data.note,
      dob:
        data.dob == null ? null : moment(data.dob).format(dateFormatOnlyDate),
      address: {
        details: data.details == null ? "" : data.details,
        province: {
          name: data.provinceName == null ? "" : data.provinceName,
          id: data.province == null ? "" : data.province,
        },
        district: {
          name: data.districtName == null ? "" : data.districtName,
          id: data.district == null ? "" : data.district,
        },
        village: {
          name: data.villageName == null ? "" : data.villageName,
          id: data.village == null ? "" : data.village,
        },
      },
    };
    userCustomerApi.createUser(payload).then(
      (res) => {
        // console.log("res", res);
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo tài khoản thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
          getUserCustomer();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateCustomer = (data) => {
    const payload = {
      avatarPath: fileImageUrl,
      email: data.email,
      name: data.name,
      gender: data.gender,
      phoneLogin: data.phoneLogin == null || !data.phoneLogin ? false : true,
      active: data.active?true:false,
      emailConfirmed:
        data.emailConfirmed == null || !data.emailConfirmed ? false : true,
      avatar: data.avatar,
      phone: data.phone,
      dob:
        data.dob == null ? null : moment(data.dob).format(dateFormatOnlyDate),
      address: {
        details: data.details == null ? "" : data.details,
        province: {
          name: data.provinceName == null ? "" : data.provinceName,
          id: data.province == null ? "" : data.province,
        },
        district: {
          name: data.districtName == null ? "" : data.districtName,
          id: data.district == null ? "" : data.district,
        },
        village: {
          name: data.villageName == null ? "" : data.villageName,
          id: data.village == null ? "" : data.village,
        },
      },
    };

    userCustomerApi.updateUser(data.id, payload).then(
      (res) => {
        if (res.status) {
          Swal.fire({
            title: "Thành Công!",
            text: res.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
          getUserCustomer();
          setImageNull(null);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      search: inputFilter.search,
      active: inputFilter.active,
      emailConfirmed: inputFilter.emailConfirmed,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Ảnh đại diện",
      dataIndex: "avatar",
      key: "avatar",
      render: (avatar) => (
        <>
          {avatar?.path && (
            <LocalImage
              width={100}
              height={100}
              style={{ objectFit: "contain" }}
              src={avatar?.path}
              alt="Avatar"
            />
          )}
          {!avatar && (
            <Image
              width={100}
              src="error"
              fallback={ENV.IMAGE_EMPTY}
              alt=" Avatar"
            />
          )}
        </>
      ),
      width: 350,
      className: "text-center",
    },
    {
      title: "Tên tài khoản",
      dataIndex: "username",
      render: (text) => <span>{text}</span>,
      fixed : 'left'

    },
    {
      title: "Họ và tên",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      sorter: false,
      className: "text-center",
      render: (text, record) => (
        <a href={`customers/${record.id}`}>{record.phone}</a>
      ),
    },
    {
      title: "Đăng nhập SĐT",
      dataIndex: "phoneLogin",
      key: "phoneLogin",
      className: "text-center",
      render: (phoneLogin) => (
        <>
          {phoneLogin === true ? (
            <Tag color="blue" key={phoneLogin}>
              Bật
            </Tag>
          ) : (
            <Tag color="red" key={phoneLogin}>
              Tắt
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Xác minh",
      dataIndex: "emailConfirmed",
      key: "emailConfirmed",
      className: "text-center",
      render: (emailConfirmed) => (
        <>
          {emailConfirmed === true ? (
            <Tag color="blue" key={emailConfirmed}>
              Đã xác minh
            </Tag>
          ) : (
            <Tag color="red" key={emailConfirmed}>
              Chưa xác minh
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      key: "active",
      className: "text-center",
      render: (active) => (
        <>
          {active ? (
            <Tag color="blue" key={active}>
              Hoạt động
            </Tag>
          ) : (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      render: (createdAt) => <>{moment(createdAt).format(dateFormat)}</>,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {listPermissions.includes(PERMISSION.Admin_UserCustomer_Update) ? (
            <>
              <Button
                onClick={() => showEditModal(record)}
                value="large"
                icon={<EditOutlined />}
              >
                Sửa
              </Button>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_UserCustomer_Delete) ? (
            <>
              <Button
                value="large"
                type="primary"
                icon={<DeleteOutlined />}
                danger
                onClick={() => deleteUser(record)}
              >
                Xóa
              </Button>
            </>
          ) : null}
        </Space>
      ),
      width: 50,
      fixed : 'right'
    },
  ];

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${newSelectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted("");
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };

  const confirm = Modal.confirm;

  const deleteUser = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa tài khoản này không?",
      onOk() {
        userCustomerApi
          .deleteUsers(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công tài khoản ");
              getUserCustomer();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteUsers = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các tài khoản này không?",
      onOk() {
        userCustomerApi
          .deleteUsers(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công tài khoản ");
              getUserCustomer();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const resetPassword = () => {
    const idUser = valueFormUser.id;

    userCustomerApi.resetPassword(idUser).then(
      (res, status) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Thành công!",
            text: res.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const showEditModal = (record) => {
    getAddressEdit("", "province");

    if (record.address !== undefined) {
      getAddressEdit(record.address.province.id, "district");
      getAddressEdit(record.address.district.id, "village");
    }
    setEditModal(true);
    setTitleModal("Sửa thông tin tài khoản");

    const avatarPath =
      record.avatar?.path === null || record.avatar?.path === undefined;
    setImageNull(avatarPath ? null : record.avatar?.path);

    // setFileList(avatar);
    setValueFormUser({
      id: record.id,
      email: record.email,
      username: record.username,
      name: record.name,
      gender: record.gender,
      phoneLogin: record.phoneLogin,
      active: record.active,
      emailConfirmed: record.emailConfirmed,
      phone: record.phone,
      dob: record.dob === null ? null : moment(record.dob),
      details: record.address !== undefined ? record.address.details : null,
      province:
        record.address !== undefined
          ? record.address?.province?.id === ""
            ? null
            : record.address.province.id
          : null,
      district:
        record.address !== undefined
          ? record.address?.district?.id === ""
            ? null
            : record.address.district.id
          : null,
      village:
        record.address !== undefined
          ? record.address?.village?.id === ""
            ? null
            : record.address.village.id
          : null,
      provinceName:
        record.address !== undefined
          ? record.address?.province?.name === ""
            ? null
            : record.address?.province?.name
          : null,
      districtName:
        record.address !== undefined
          ? record.address?.district?.name === ""
            ? null
            : record.address?.district?.name
          : null,
      villageName:
        record.address !== undefined
          ? record.address?.village?.name === ""
            ? null
            : record.address.village.name
          : null,
    });
    console.log(record);
    setIsModalEditContractVisible(true);
  };

  const showCreateModal = () => {
    setImageNull(null);
    getAddress("", "province");
    setTitleModal("Thêm tài khoản");
    setValueFormUser({
      email: "",
      password: "1234567a@",
      username: "",
      name: "",
      gender: null,
      phoneLogin: null,
      status: null,
      emailConfirmed: null,
      avatar: null,
      phone: "",
      dob: null,
      details: null,
      province: null,
      village: null,
      district: null,
      provinceName: null,
      districtName: null,
      villageName: null,
    });
    setEditModal(false);
    setIsModalEditContractVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateCustomer(values);
      } else {
        createCustomer(values);
      }
    },
    [isEditModal, fileImageUrl]
  );

  const closePopup = useCallback(() => {
    setValueFormUser();
    form.resetFields();
    setImageNull(null);
    setIsModalEditContractVisible(false);
  }, [form]);

  const { Option } = Select;

  const onChangeSelectProvine = (value, name) => {
    getAddress(value, "district");
    form.setFieldsValue({
      provinceName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectDistrict = (value, name) => {
    getAddress(value, "village");
    form.setFieldsValue({
      districtName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectVillage = (value, name) => {
    form.setFieldsValue({
      villageName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const handleCancel = () => setPreviewVisible(false);

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={24}>
            <Col span={6}>
              <label> Tìm kiếm</label>
              <br />
              <Input
                addonAfter={<UserOutlined />}
                defaultValue={inputFilter.search}
                placeholder="Nhập tài khoản, tên,email hoặc số điện thoại..."
                onChange={getCustomerDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6}>
              <label className="">Xác Minh</label>
              <br />

              <Select
                defaultValue={inputFilter.emailConfirmed}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1,emailConfirmed: e });
                }}
              >
                <Option value="">---Mặc định---</Option>
                <Option value="true">Đã xác minh</Option>
                <Option value="false">Chưa xác minh</Option>
              </Select>
            </Col>
            <Col span={6}>
              <label className="">Trạng thái</label>
              <br />

              <Select
                defaultValue={inputFilter.active}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  setFilter({ ...inputFilter, active: e });
                }}
              >
                <Option value="">---Mặc định---</Option>
                <Option value="true">Hoạt động</Option>
                <Option value="false">Bị khóa</Option>
              </Select>
            </Col>
          </Row>
        </Card>
        <br />
        <Space size={10}>
          {listPermissions.includes(PERMISSION.Admin_UserCustomer_Create) ? (
            <>
              <Button
                type="dashed"
                onClick={() => showCreateModal()}
                size="small"
              >
                <EditOutlined /> &nbsp; Thêm tài khoản
              </Button>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_UserCustomer_Delete) ? (
            <>
              {btnDeleted ? (
                <Button
                  value="small"
                  type="primary"
                  icon={<AiFillDelete />}
                  danger
                  onClick={() => {
                    deleteUsers();
                  }}
                >
                  &nbsp; Xóa các tài khoản được chọn
                </Button>
              ) : null}
            </>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={userCustomers}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>

        <Modal
          title={titleModal}
          visible={isModalEditContractVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              initialValues={valueFormUser}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Tabs defaultActiveKey="1">
                <TabPane tab="TT tài khoản" key="1">
                  {isEditModal ? (
                    <>
                      <Form.Item hidden={true} label="Id" name="id">
                        <Input />
                      </Form.Item>

                      <Form.Item label="Tài khoản" name="username">
                        <Input disabled />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      label="Tài khoản"
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: "Vui lòng nhập tên tài khoản!",
                        },
                      ]}
                    >
                      <Input
                        maxLength={30}
                        addonAfter={<UserOutlined />}
                        placeholder="Nhập tài khoản..."
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    label="Họ và tên"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập họ và tên!",
                      },
                    ]}
                  >
                    <Input
                      maxLength={150}
                      addonAfter={<IdcardOutlined />}
                      placeholder="Nhập họ tên..."
                    />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập email!",
                      },
                      {
                        type: "email",
                        message: "Email không đúng định dạng!",
                      },
                    ]}
                  >
                    <Input
                      addonAfter={<AiOutlineMail />}
                      placeholder="Nhập email..."
                    />
                  </Form.Item>
                  <Form.Item
                    label="Số điện thoại"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập số điện thoại!",
                      },
                      {
                        pattern: new RegExp(/^[0-9]+$/),
                        message: "Số điện thoại không đúng định dạng!",
                      },
                    ]}
                  >
                    <Input
                      addonAfter={<AiOutlineMobile />}
                      placeholder="Nhập số điện thoại..."
                    />
                  </Form.Item>

                  {isEditModal ? (
                    <>
                      <Form.Item label="Mật khẩu" name="password">
                        <Button
                          value="small"
                          type="primary"
                          onClick={() => resetPassword()}
                          style={{ background: "black", borderColor: "white" }}
                        >
                          Reset mật khẩu
                        </Button>
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      label="Mật khẩu"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  )}

                  <Row gutter={24}>
                    <Col span={6}>
                      <Form.Item
                        label="Trạng thái"
                        valuePropName="checked"
                        name="active"
                      >
                        <Switch />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label="Xác minh"
                        valuePropName="checked"
                        name="emailConfirmed"
                      >
                        <Switch />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        label="Đăng nhập SĐT"
                        valuePropName="checked"
                        name="phoneLogin"
                      >
                        <Switch />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="TT Cá nhân" key="2">
                  <Form.Item label="Ảnh đại diện" name="avatar">
                    <UploadFile />
                    <Modal
                      visible={previewVisible}
                      title={previewTitle}
                      footer={null}
                      onCancel={handleCancel}
                    >
                      <img
                        alt="example"
                        style={{
                          width: "100%",
                        }}
                        src={previewImage}
                      />
                    </Modal>
                  </Form.Item>
                  <Form.Item label="Giới tính" name="gender">
                    <Select
                      showArrow
                      size="large"
                      // onChange={handleChange}
                      placeholder="Chọn..."
                    >
                      <Option value="male">Nam</Option>
                      <Option value="female">Nữ</Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Ngày sinh" name="dob">
                    <DatePicker format={dateFormatUTC} />
                  </Form.Item>
                </TabPane>
                <TabPane tab="Địa chỉ" key="3">
                  <Form.Item label="Địa chỉ chi tiết" name="details">
                    <Input placeholder="Nhập địa chỉ..." />
                  </Form.Item>

                  <Form.Item label="Tỉnh/Thành Phố" name="province">
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      onChange={onChangeSelectProvine}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {province == null ||
                      province === "undefined" ||
                      province === []
                        ? []
                        : province.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label="Quận/Huyện" name="district">
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectDistrict}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {district == null ||
                      district === "undefined" ||
                      district === []
                        ? []
                        : district.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label="Phường/Xã" name="village">
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectVillage}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {village == null ||
                      village === "undefined" ||
                      village === []
                        ? []
                        : village.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    hidden={true}
                    label="provinceName"
                    name="provinceName"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    hidden={true}
                    label="districtName"
                    name="districtName"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    hidden={true}
                    label="villageName"
                    name="villageName"
                  >
                    <Input />
                  </Form.Item>
                </TabPane>
              </Tabs>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default UserCustomer;
